import { EQUALS, DOES_NOT_EQUAL } from 'utils/comparatorTypes';
import { MULTI_SELECT_FIELDS } from '../constants';

export const getIsMultiSelectInput = ({
  comparator,
  values,
  field,
  isMultiSelectInputAllowed,
  isMultiSelectWithListMembershipAllowed,
}: {
  comparator: string;
  values?: string[];
  field: string;
  isMultiSelectInputAllowed: boolean;
  isMultiSelectWithListMembershipAllowed: boolean;
}) => {
  const isCampaignFieldSelected = MULTI_SELECT_FIELDS.includes(field);
  return (
    (comparator === EQUALS || comparator === DOES_NOT_EQUAL) &&
    Array.isArray(values) &&
    !isCampaignFieldSelected &&
    (isMultiSelectInputAllowed || isMultiSelectWithListMembershipAllowed)
  );
};
